module.exports = __webpack_public_path__ + "img/loading.efdeb5db.svg";